import {insert, insertAfter} from "@codeArt/utils/array";
import { getItems } from "./data";
let _ = require("lodash");

//处理sidebar中的菜单项
export function process(appName,sidebar,{matchUrl,routes}){
    let items = getItems(appName);
    if(!items || items.length===0) return {sidebar,routes};

    sidebar=sidebar||{};
    if(!sidebar.menus) sidebar.menus =[];
    let root = {children:sidebar.menus};

    items.forEach(({position,content})=>{
         let rs = processItem(root,position,content,matchUrl);
         if(rs) routes = routes.concat(rs);
    });
    sidebar.menus = merge(root.children); //重新赋值
    return {sidebar,routes};
}

const processItem =(root,position,content,matchUrl)=>{

    const {action,path} = position;

    let {menu,menus,routes} = content(matchUrl);
    menus = menus || [menu];

    switch(action){
        //将配置的菜单放在根菜单的第一项或最后一项
        case "first":
        case "last": return process_item_by(root,position,menus,routes);
        case "insertBefore":
        case "insertAfter":
        //放在子菜单中的第一项
        case "insertChildrenFirst" :return process_item_by_path(root,position,path,menus,routes);
    }
}


const process_item_by =(root,position,menus,routes)=>{

    const {action} = position;

    switch(action){
        case "first":{
            for(let i=0;i<menus.length;i++){
                let menu=menus[i];
                if(!menu) continue; //有可能menu因为适配平台原因，变为null了
                root.children = insert(root.children,i,menu);
            }
            return routes;
        }
        case "last":{
            for(let i=0;i<menus.length;i++){
                let menu=menus[i];
                if(!menu) continue; //有可能menu因为适配平台原因，变为null了
                root.children = insertAfter(root.children,root.children.length-1,menu);
            }
            return routes;
        }
    }
}

const process_item_by_path =(root,position,path,menus,routes)=>{

    const {action} = position;
    let target = findTarget([...path],root)
    if(!target) return; //没有找到

    let parent = target.parent;
    let index = target.index;

    switch(action){
        case "insertBefore":{
            for(let i=0;i<menus.length;i++){
                let menu=menus[i];
                if(!menu) continue; //有可能menu因为适配平台原因，变为null了
                parent.children = insert(parent.children,index+i,menu);
            }
            return routes;
        }
        case "insertAfter":{
            for(let i=0;i<menus.length;i++){
                let menu=menus[i];
                if(!menu) continue; //有可能menu因为适配平台原因，变为null了
                parent.children = insertAfter(parent.children,index+i,menu);
            }
            return routes;
        }
        case "insertChildrenFirst":{
            for(let i=0;i<menus.length;i++){
                let menu=menus[i];
                if(!menu) continue; //有可能menu因为适配平台原因，变为null了
                target.children = insert(target.children,i,menu);
            }
            return routes;
        }
    }
}

const findTarget = (path,parent)=>{
    if(!parent || !parent.children) return null; //无法继续找了
    let menus = parent.children;
    let name = path.shift();
    
    let index = _.findIndex(menus,(menu)=> menu && menu.name===name );
    if(index < 0) return null;
    if(path.length===0) return {index,parent,children:menus[index].children||[]}; //找到了

    //继续找
    let menu = menus[index];
    return findTarget(path,menu);
}


const merge = (menus)=>{    //将menus里的重复项合并
    let l = [];
    menus.forEach((m)=>{
        let target = _.find(l,(t)=>t.name===m.name);
        if(target) {
            let cs = _.concat(target.children||[],m.children||[]);
            target.children = merge(cs);
            return;
        }
        l.push(m);
    });
    return l;
}